import { useEffect, useState } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import ModalAddUserRol from "./add-user-rol";
import DeleteUserRol from "./delete-user-rol";
import ModalListRoles from "./list-roles";
import "./roles.css";
import { instance, laptop1300 } from "../../../../utils/utils";
import EditUserRol from "./edit-user-rol";
import RecentActivitiesModal from "./recent-activities-modal";

const styleModal = {
    display: "flex",
    position: "fixed",
    zIndex: 999,
    whiteSpace: "pre-line",
};

const ContainerRoles = ({ onClose }) => {
    const [detailCompany, setDetailCompany] = useState([]);
    const [action, setAction] = useState("list");
    const [rolesSelected, setRolesSelected] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const [loader, setLoader] = useState(false);
    const [usersLogs, setUsersLogs] = useState();
    const [showUsersLogsModal, setShowUsersLogsModal] = useState(false);

    function getCompanyDetail() {
        setLoader(true);
        instance
            .get(`memberships/corp/company`)
            .then((res) => res.data)
            .then((data) => {
                setDetailCompany(data);

                setLoader(false);
            })
            .catch((err) => console.error(err));
    }

    function getUserRoles() {
        setLoader(true);
        instance
            .get("users/roles/")
            .then((res) => res.data)
            .then((data) => {
                setUserRoles(data);
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setLoader(false);
            });
    }

    const getUsersLogs = () => {
        instance
            .get(`memberships/logs/`)
            .then((res) => res.data)
            .then((data) => {
                setUsersLogs(data);
            })
            .catch((err) => console.error(err));
    }

    useEffect(() => {
        getUserRoles();
        getCompanyDetail();
        getUsersLogs();
    }, [action]);

    const responsiveWidth = laptop1300.matches
        ? "calc(70vw - 20rem)"
        : "calc(85vw - 20rem)";

    return (
        <>
            <div
                className="popUpServices justify-content-center align-items-center"
                style={styleModal}
            >
                <div
                    className="modalInfoContenido"
                    style={{
                        background: "white",
                        borderRadius: "20px",
                        boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                        padding: "6% 7%",
                        minWidth: action === "list" ? responsiveWidth : "30rem",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "5%",
                            right: "5%",
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            color: " #9DACBD",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            if (action === "list") {
                                onClose();
                            } else if (action === "add") {
                                setAction("list");
                                setRolesSelected([]);
                            } else if (action === "edit") {
                                setAction("list");
                                setRolesSelected([]);
                            } else if (action === "delete") {
                                setAction("list");
                                setRolesSelected([]);
                            } else {
                                onClose();
                            }
                        }}
                    >
                        <i className="bi bi-x-circle"></i>
                    </div>

                    <div
                        className="pt-3 my-4 mx-auto"
                        style={{
                            lineHeight: "100%",
                            textAlign: "center",

                            color: "var(--elevvabutonLogin_User)",
                        }}
                    >
                        {action === "list" && (
                            <ModalListRoles
                                detailCompany={detailCompany}
                                loader={loader}
                                userRoles={userRoles}
                                onConfirm={(action) => setAction(action)}
                                rolesSelected={rolesSelected}
                                setRolesSelected={setRolesSelected}
                                setShowUsersLogsModal={setShowUsersLogsModal}
                            />
                        )}
                        {action === "add" && (
                            <ModalAddUserRol
                                onClose={() => {
                                    setAction("list");
                                    setRolesSelected([]);
                                }}
                            />
                        )}
                        {action === "edit" && (
                            <EditUserRol
                                onClose={() => {
                                    setAction("list");
                                    setRolesSelected([]);
                                }}
                                user={userRoles.find((user) => user.id === rolesSelected[0])}
                            />
                        )}
                        {action === "delete" && (
                            <DeleteUserRol
                                onClose={() => {
                                    setAction("list");
                                    setRolesSelected([]);
                                }}
                                rolesSelected={rolesSelected}
                            />
                        )}
                    </div>
                </div>
            </div>

            {showUsersLogsModal && (
                <RecentActivitiesModal
                    show={showUsersLogsModal}
                    onClose={() => setShowUsersLogsModal(false)}
                    usersLogs={usersLogs}
                    setUserLogs={setUsersLogs}
                />
            )}
        </>

    );
};
export default ContainerRoles;
